import styled from 'styled-components'

export const StyledUl = styled.ul`
  padding: ${({ theme }) => theme.space[4]}px 0 0 0;
`
